<template>
  <div class="wrap">
    <div class="title">
      <div class="title_left">规章制度</div>
    </div>
    <div class="innerBox">
      <div class="filtrate">
        <el-input placeholder="请输入规章制度名称" class="w260 seekIpt mr20" v-model="queryLimit.keyword" @keyup.enter.native="searchPage">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchPage"></i>
        </el-input>
      </div>
      <div class="operate clear_a">
        <div class="left mt20">
          <el-button class="selectHeight mr20" type="primary" @click="openAdd">
            <i style="margin-right: 5px;font-weight: 700;color: #fff;" class="el-icon-plus"></i>新增
          </el-button>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="content">
        <div class="tabOffTop120">
          <el-table ref="multipleTable" :data="tableData.records" tooltip-effect="dark" style="width: 100%">
            <el-table-column type="index" width="55" label="序号">
              <template slot-scope="scope">
                {{(queryLimit.size * (queryLimit.current - 1) + scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column  prop="name" label="制度名称" min-width="180"  show-overflow-tooltip></el-table-column>
            <el-table-column prop="type" min-width="120" label="制度类型" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="orderNum" min-width="90" label="排序">
            </el-table-column>
            <el-table-column prop="createTime" min-width="180" label="创建时间" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="updateTime" min-width="180" label="更新时间" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" min-width="180">
              <template slot-scope="scope">
                <a href="javascript:;" class="operate-a" @click="openDetail(scope.row)">详情</a>
                <a href="javascript:;" class="operate-a" @click="openEdit(scope.row)">编辑</a>
                <a href="javascript:;" class="operate-a" @click="delConfirm(scope.row.id)">删除</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="mt20 mb20 rowybUploadText">提示：相同排序的规章制度, 按照更新时间排序, 最近更新的排序在前</div>
        <div class="pagination-box">
          <el-pagination background @size-change="pageSizeChange" @current-change="pageCurrentChange"
                          :current-page="queryLimit.current" :page-sizes="[10, 20, 30, 40,50]" :page-size="queryLimit.size"
                          layout="total,prev, pager, next, sizes, jumper" :total="tableData.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as api from "api/regulation";
  export default {
    name: "regulationList",
    data() {
      return {
        queryLimit: {
          current: 1,
          keyword: "",
          size: 10
        },
        tableData: [],
      };
    },
    methods: {
      pageCurrentChange(current) {
          this.queryLimit.current = current;
          this.getPageData();
      },
      pageSizeChange(size) {
          this.queryLimit.size = size;
          this.getPageData();
      },
      // 删除
      async delConfirm(id){
          try {
              await this.$confirm('是否确认永久删除该规章制度? ', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              })
              api.regulationDel({id: id}).then(res => {
                if(res.code === 200) {
                  this.$message.success('删除成功!');
                  this.getPageData();
                }
              }).catch(err => {})
          } catch (e) {
              this.$message({
                  type: 'info',
                  message: '删除失败'
              });
          }
      },
      openDetail(row) {
        this.$router.push({name: 'regulation.detail', query: {type: 'detail', id: row.id}})
      },
      openEdit(row){
        this.$router.push({name: 'regulation.addAndEdit', query: {type: 'edit', id: row.id}})
      },
      openAdd(){
        this.$router.push({name: 'regulation.addAndEdit', query: {type: 'add'}})
      },
      searchPage(){
        this.queryLimit.current = 1;
        this.getPageData();
      },
      async getPageData(){
        api.regulationList(this.queryLimit).then(res => {
          if(res.code === 200) {
            this.tableData = res.data
            // this.tableData.total = res.data.total
          }
        }).catch(err => {})
      }
    },
    mounted() {
      this.getPageData();
    }
  };
</script>

<style scoped lang="scss">
  .line {
    width: 100%;
    height: 1px;
    background: #eeeeee;
  }
  .wrap {
    width: calc(100% - 40px);
    padding: 0 20px;
    height: 100%;
    background: #f6f6f6;
    .title {
      height: 60px;
      line-height: 60px;
      .title_left {
        font-size: 20px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        width: 50%;
        height: 100%;
      }
    }
    .innerBox {
      width: calc(100% - 60px);
      padding: 20px 30px;
      height: calc(100% - 125px);
      background: #fff;
      border-radius: 10px;
      overflow: scroll;
      .filtrate {
        vertical-align: center;
        .year {
          font-size: 12px;
          line-height: 18px;
          color: #666666;
        }
      }
      .operate {
        .left {
          float: left;
        }
        .right {
          float: right;
        }
      }
    }
    .pagination-box {
      text-align: right;
      margin-top: 20px;
    }
  }
</style>